"use strict";
exports.__esModule = true;
exports.ExtraIsLoading$ = exports.ExtraLoaded$ = exports.ExtraQuery = void 0;
var akita_1 = require("@datorama/akita");
var extra_store_1 = require("./extra.store");
var operators_1 = require("rxjs/operators");
exports.ExtraQuery = akita_1.createQuery(extra_store_1.ExtraStore);
exports.ExtraLoaded$ = exports.ExtraQuery.select().pipe(operators_1.filter(function (state) { return state && !state.loading; }), operators_1.switchMap(function () { return exports.ExtraQuery.select(); }));
exports.ExtraIsLoading$ = exports.ExtraQuery.selectLoading();
//# sourceMappingURL=extra.query.js.map